export const companySizes = [
  'TPE (1-9 employés)',
  'Petite entreprise (10-49 employés)',
  'Moyenne entreprise (50-249 employés)',
  'ETI (250-4999 employés)',
  'Grande entreprise (5000+ employés)'
];